function buildPropsToDisplayArray(propsToDisplay = []) {
  return propsToDisplay.map(prop => !!prop && !!prop.propertiesToDisplay && prop.propertiesToDisplay[0]).filter(Boolean);
}
export default buildPropsToDisplayArray;
//# sourceMappingURL=build-props-to-display-array.js.map